export default "__VITE_ASSET__DWrsJ$US__"